/* Sereolys cocoony pink-advertorial kit: autoplay feature videos, render Splide
 * carousels as static rows (library not on this store), wire the before/after
 * slider, one sticky CTA -> buy-box, route all CTAs to the buy-box. */
(function () {
  'use strict';

  var vIO = null;
  function videos() {
    if (!vIO && 'IntersectionObserver' in window) {
      vIO = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        });
      }, { threshold: 0.15 });
    }
    document.querySelectorAll('.pk2 video').forEach(function (v) {
      if (v.__pk) return; v.__pk = 1;
      v.muted = true; v.loop = true; v.autoplay = true;
      v.setAttribute('muted', ''); v.setAttribute('autoplay', '');
      v.setAttribute('playsinline', ''); v.removeAttribute('controls');
      var go = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      if (v.readyState >= 2) go(); else v.addEventListener('loadeddata', go);
      v.addEventListener('pause', function () { if (isVisible(v)) setTimeout(go, 30); });
      if (vIO) vIO.observe(v);
      setTimeout(go, 500);
    });
    /* Dawn's <internal-video> may not upgrade here; reveal its <video> */
    document.querySelectorAll('.pk2 internal-video').forEach(function (iv) {
      iv.style.display = 'block';
    });
  }
  function isVisible(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < (window.innerHeight || 800);
  }
  /* enforcer: keep every in-view feature video playing (autoplay works once
   * triggered, but the initial play() can be dropped during page load) */
  function playVisible() {
    document.querySelectorAll('.pk2 video').forEach(function (v) {
      if (v.paused && isVisible(v) && v.readyState >= 2) {
        v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
    });
  }

  /* Splide isn't loaded — show every slide as a flat responsive row/grid */
  function splide() {
    document.querySelectorAll('.pk2 .splide').forEach(function (sp) {
      if (sp.__pk) return; sp.__pk = 1;
      sp.classList.add('is-initialized');
      var track = sp.querySelector('.splide__track'); if (track) { track.style.overflow = 'visible'; track.style.height = 'auto'; }
      var list = sp.querySelector('.splide__list');
      if (list) {
        list.style.transform = 'none'; list.style.display = 'flex';
        list.style.flexWrap = 'wrap'; list.style.width = 'auto'; list.style.justifyContent = 'center'; list.style.gap = '16px';
      }
      sp.querySelectorAll('.splide__slide').forEach(function (s) { s.style.opacity = '1'; s.style.visibility = 'visible'; });
      sp.querySelectorAll('.splide__arrows, .splide__pagination').forEach(function (a) { a.style.display = 'none'; });
    });
  }

  /* custom before/after slider: drag the divider, clip the top image */
  function compare() {
    document.querySelectorAll('.pk2 [data-pkba]').forEach(function (sl) {
      if (sl.__pk) return; sl.__pk = 1;
      var top = sl.querySelector('.pkba__top'), div = sl.querySelector('.pkba__divider');
      if (!top || !div) return;
      var set = function (v) {
        v = Math.max(0, Math.min(100, v));
        top.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
        div.style.left = v + '%';
      };
      var pct = function (e) {
        var r = sl.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
        return x / r.width * 100;
      };
      var dragging = false;
      var down = function (e) { dragging = true; set(pct(e)); e.preventDefault(); };
      var move = function (e) { if (dragging) set(pct(e)); };
      var up = function () { dragging = false; };
      sl.addEventListener('pointerdown', down);
      window.addEventListener('pointermove', move, { passive: true });
      window.addEventListener('pointerup', up);
      sl.addEventListener('touchstart', down, { passive: false });
      window.addEventListener('touchmove', move, { passive: true });
      window.addEventListener('touchend', up);
      set(50);
    });
  }

  /* target the BUNDLES / offer tiers first (that's where CTAs should land) */
  function buyBox() {
    return document.querySelector('.lumin-product-block-qty-break, [class*="quantity-break"], [class*="bundle-save"]') ||
           document.querySelector('product-form, .product-form, [id*="__main"] .product-form__buttons') ||
           document.querySelector('[id*="template--"][id*="__main"], #MainContent');
  }
  function goBuyBox() {
    var el = buyBox(); var to = el ? Math.max(0, window.scrollY + el.getBoundingClientRect().top - 20) : 0;
    var from = window.scrollY, d = to - from, t0 = Date.now();
    clearInterval(window.__pkTw);
    window.__pkTw = setInterval(function () {
      var k = Math.min(1, (Date.now() - t0) / 480);
      var s = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
      window.scrollTo(0, Math.round(from + d * s)); if (k >= 1) clearInterval(window.__pkTw);
    }, 16);
  }
  function wireCtas() {
    document.querySelectorAll('.pk2 a, .pk2 button.pk-cta, .pk2 [class*="button"]').forEach(function (a) {
      if (a.__pk || a.closest('.splide__arrows')) return; a.__pk = 1;
      var h = a.getAttribute && (a.getAttribute('href') || '');
      if (/^(mailto:|tel:)/i.test(h || '')) return;
      if (a.tagName === 'SUMMARY' || a.closest('summary')) return;
      a.addEventListener('click', function (e) { e.preventDefault(); goBuyBox(); });
    });
  }

  /* hide the theme's own offer stickies + promos; ONE #pk2-sticky remains */
  var st = null, shown = null, sen = null;
  function buildSticky() {
    if (document.getElementById('pk2-sticky')) return;
    st = document.createElement('button'); st.id = 'pk2-sticky'; st.type = 'button';
    st.textContent = 'Profiter de l’offre';
    document.body.appendChild(st);
    st.addEventListener('click', function (e) { e.preventDefault(); goBuyBox(); });
  }
  function checkSticky() {
    if (!st) return; if (!sen) sen = buyBox();
    var v = sen ? (sen.getBoundingClientRect().bottom < 0) : (window.scrollY > 700);
    if (v === shown) return; shown = v;
    st.style.setProperty('display', v ? 'inline-flex' : 'none', 'important');
  }

  function init() { videos(); splide(); compare(); wireCtas(); buildSticky(); checkSticky(); }
  if (document.readyState !== 'loading') init();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  setTimeout(init, 600); setTimeout(init, 1800);
  window.addEventListener('scroll', checkSticky, { passive: true });
  window.addEventListener('scroll', playVisible, { passive: true });
  window.addEventListener('resize', checkSticky);
  setInterval(checkSticky, 400);
  setInterval(playVisible, 700);
})();
